/**
 * ov1uir
 * previously components/offers/layout.th.tsx
 * no functional changes
 * TODO: determine how much of this can be moved to new v2 UI
 */
import React from 'react';

import { Icon } from '@rbilabs/components-library/build/components/icon';
import { Box } from '@rbilabs/components-library/build/components/layout';
import { useIntl } from 'react-intl';

import ActionButton, { ActionButtonSizes } from 'components/action-button';
import { IOfferLayoutProps } from 'components/offer/types';
import { countDown } from 'components/offer/utils';
import useMediaQuery from 'hooks/use-media-query';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { OfferActivationStatus } from 'utils/offers';

import { TWELVE_DAYS_RANK_OFFER } from './constants';
import {
  Heading,
  OfferContent,
  OfferContentWrap,
  OfferExpiration,
  SanityDescription,
  StyledPicture,
  Wrapper,
} from './styled';
import { THOfferTag } from './th-offer-tag';

const OfferLayout: React.FC<IOfferLayoutProps> = ({
  className,
  offer,
  onClick,
  state,
  isGridLayout,
}) => {
  const { formatMessage } = useIntl();
  const isDesktop = useMediaQuery('desktop');
  const heading = offer?.name?.localeRaw?.[0]?.children?.[0]?.text ?? '';
  const enableTHOfferTag = useFlag(LaunchDarklyFlag.ENABLE_TH_OFFER_TAGS);

  // Replace the endDate variable to localized and formatted date
  const expiresOnDatetime = countDown(offer?.expiresOnDatetime || new Date(), formatMessage);

  const shouldDisplayOfferTag = () => {
    return enableTHOfferTag && offer.rank === TWELVE_DAYS_RANK_OFFER;
  };

  return (
    <Wrapper
      className={className}
      onClick={onClick}
      data-testid="offer-layout"
      $isGridLayout={isGridLayout}
    >
      {offer?.localizedImage?.locale?.app && (
        <StyledPicture
          placeholderAspectRatio={1.5}
          objectFitContain={false}
          image={offer?.localizedImage?.locale?.app!}
          alt=""
        />
      )}
      <OfferContent>
        <OfferContentWrap>
          <Heading>{heading}</Heading>
          {offer?.description?.localeRaw && (
            <SanityDescription content={offer?.description?.localeRaw} />
          )}
          <OfferExpiration>{expiresOnDatetime}</OfferExpiration>
          {shouldDisplayOfferTag() && (
            <THOfferTag aria-label={formatMessage({ id: 'twelveDaysOfTims' })}>
              {formatMessage({ id: 'twelveDaysOfTims' })}
            </THOfferTag>
          )}
        </OfferContentWrap>
        <Box margin="0 auto" width="100%">
          {state && state !== OfferActivationStatus.ACTIVATED ? (
            <ActionButton
              size={isDesktop ? ActionButtonSizes.LARGE : ActionButtonSizes.SMALL}
              fullWidth
              skipLogEvent
            >
              {formatMessage({ id: 'activate' })}
            </ActionButton>
          ) : (
            <ActionButton
              size={isDesktop ? ActionButtonSizes.LARGE : ActionButtonSizes.SMALL}
              fullWidth
              disabled
              startIcon={<Icon icon="check" color="white" aria-hidden />}
            >
              {formatMessage({ id: 'activated' })}
            </ActionButton>
          )}
        </Box>
      </OfferContent>
    </Wrapper>
  );
};

export default OfferLayout;
